import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);

  // 장바구니 개수 조회
  const fetchCartCount = async () => {
    try {
      const res = await axios.get("/api/cart/count", {
        withCredentials: true,
      });
      setCartCount(res.data.count || 0);
    } catch {
      setCartCount(0);
    }
  };

  // 장바구니 전체 가져오기 (Cart 컴포넌트용)
  const fetchCartItems = async () => {
    try {
      const res = await axios.get("/api/cart", { withCredentials: true });
      const items = res.data.cart_items || [];
      setCartCount(items.length); // 개수 자동 반영
      return items;
    } catch {
      setCartCount(0);
      return [];
    }
  };

  // 로그아웃 시 초기화
  const clearCart = () => {
    setCartCount(0);
  };

  useEffect(() => {
    fetchCartCount();
  }, []);

  return (
    <CartContext.Provider value={{ cartCount, setCartCount, fetchCartCount, fetchCartItems, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
